import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SpinnerDialogComponent, SpinnerDialogConfig, SpinnerDialogData } from './spinner-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class SpinnerDialogService {
  private dialogRef: MatDialogRef<SpinnerDialogComponent> | null = null;

  constructor(private dialog: MatDialog) {}

  open(data: SpinnerDialogData): MatDialogRef<SpinnerDialogComponent> {
    // Only ever one spinner at a time - opening a second would orphan the first
    // and leave an overlay nothing can close.
    this.close();
    const config = new SpinnerDialogConfig();
    config.data = data;
    this.dialogRef = this.dialog.open(SpinnerDialogComponent, config);
    return this.dialogRef;
  }

  show(message: string, diameter: number = 40): MatDialogRef<SpinnerDialogComponent> {
    return this.open({ message, diameter });
  }

  close(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
}
